module.exports = __webpack_public_path__ + "static/media/Mod1.70fda3a5.png";